var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatchback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.432 450C462.295 450 479.209 433.086 479.209 412.223C479.209 391.359 462.295 374.445 441.432 374.445C420.568 374.445 403.654 391.359 403.654 412.223C403.654 433.086 420.568 450 441.432 450Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.689 450C191.553 450 208.467 433.086 208.467 412.223C208.467 391.359 191.553 374.445 170.689 374.445C149.826 374.445 132.912 391.359 132.912 412.223C132.912 433.086 149.826 450 170.689 450Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.686 426.836H586.216C601.849 426.836 614.503 414.182 614.503 398.549V343.883H119.111V414.235C119.111 421.189 124.732 426.836 131.686 426.836Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M566.814 450C587.678 450 604.592 433.086 604.592 412.223C604.592 391.359 587.678 374.445 566.814 374.445C545.951 374.445 529.037 391.359 529.037 412.223C529.037 433.086 545.951 450 566.814 450Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M566.813 434.004C578.84 434.004 588.59 424.254 588.59 412.227C588.59 400.199 578.84 390.449 566.813 390.449C554.785 390.449 545.035 400.199 545.035 412.227C545.035 424.254 554.785 434.004 566.813 434.004Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.635 450C339.498 450 356.412 433.086 356.412 412.223C356.412 391.359 339.498 374.445 318.635 374.445C297.771 374.445 280.857 391.359 280.857 412.223C280.857 433.086 297.771 450 318.635 450Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.633 434.004C330.66 434.004 340.41 424.254 340.41 412.227C340.41 400.199 330.66 390.449 318.633 390.449C306.606 390.449 296.855 400.199 296.855 412.227C296.855 424.254 306.606 434.004 318.633 434.004Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M623.468 338.208L622.579 351.567L622.344 355.175L618.919 405.893C618.579 411.017 614.318 414.991 609.194 414.991V401.71C609.194 393.684 606.971 386.155 603.128 379.75C601.324 376.691 599.128 373.894 596.645 371.41C588.749 363.541 577.769 358.678 565.743 358.861C550.502 359.044 537.299 367.462 529.874 379.776C525.77 386.521 523.417 394.469 523.417 402.861V415.043H361.642V402.887C361.642 394.521 359.289 386.573 355.184 379.802C352.648 375.593 349.433 371.828 345.694 368.717C338.74 362.887 329.93 359.227 320.257 358.913C295.786 358.051 275.708 377.606 275.708 401.867V415.07H119.266L85.2012 379.514V342.391C85.2012 337.842 88.4691 333.999 92.9396 333.241L210.637 313.398L274.715 253.163C276.911 251.124 279.787 250 282.741 250H537.038C540.201 250 543.208 251.281 545.378 253.529L610.579 320.352L610.997 320.77L620.723 330.731C622.657 332.718 623.625 335.437 623.468 338.208Z",
    fill: "url(#paint0_linear_4939_641)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M388.833 256.902L359.84 316.405H216.914L278.482 258.863C279.841 257.608 281.619 256.902 283.475 256.902H388.833Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.207 256.902V316.405H373.039L402.084 256.902H479.207Z",
    fill: "#09081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M585.664 316.405H491.104V256.902H534.24C536.332 256.902 538.345 257.765 539.783 259.281L588.2 310.549C590.292 312.771 588.723 316.405 585.664 316.405Z",
    fill: "#09081A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M254.35 395.515H87.0325C80.9411 395.515 76 390.574 76 384.483C76 378.392 80.9411 373.477 87.0064 373.477H254.324C260.416 373.477 265.331 378.418 265.331 384.483C265.357 390.574 260.416 395.515 254.35 395.515Z",
    fill: "#09081A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M378.347 250L343.838 316.404L259.708 331.594C254.401 332.561 250.532 337.162 250.532 342.574V395.514V414.991H119.292L85.2012 379.514V342.391C85.2012 337.842 88.4691 333.999 92.9396 333.241L210.637 313.398L274.715 253.163C276.911 251.124 279.787 250 282.741 250H378.347Z",
    fill: "url(#paint1_linear_4939_641)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.345 361.945H203.189C200.182 361.945 197.725 359.513 197.725 356.481V348.847C197.725 345.84 200.156 343.383 203.189 343.383H227.345C230.352 343.383 232.809 345.814 232.809 348.847V356.481C232.809 359.513 230.352 361.945 227.345 361.945Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.6 348.871V356.479C108.6 359.486 106.168 361.943 103.136 361.943H85.2012V343.434H103.162C106.168 343.434 108.6 345.865 108.6 348.871Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M614.502 379.729H603.103C601.299 376.67 599.103 373.873 596.62 371.389C588.724 363.52 577.744 358.657 565.718 358.84C550.477 359.023 537.274 367.442 529.85 379.755H355.185C352.649 375.546 349.434 371.781 345.695 368.67L366.845 323.887H589.221C592.96 323.887 596.28 326.266 597.483 329.769L614.502 379.729Z",
    fill: "url(#paint2_linear_4939_641)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M362.061 333.921L366.819 323.855H589.142",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M623.471 338.208L622.582 351.567L622.347 355.175C615.863 355.175 610.582 349.92 610.582 343.41V320.352L611 320.77L620.726 330.73C622.66 332.717 623.628 335.436 623.471 338.208Z",
    fill: "#067244"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.729 343.258H115.945V366.578H188.729V343.258Z",
    fill: "#09081A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M619.624 395.484H608.723",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M523.992 395.484H361.014",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4939_641",
    x1: 354.343,
    y1: 248.048,
    x2: 354.343,
    y2: 413.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5017,
    stopColor: "#05D585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B06B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4939_641",
    x1: 290.795,
    y1: 351.574,
    x2: 196.631,
    y2: 308.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4939_641",
    x1: 480.09,
    y1: 311.395,
    x2: 480.09,
    y2: 377.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    stopColor: "#00180F",
    stopOpacity: 0.2533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#015736",
    stopOpacity: 0.1542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    stopColor: "#02BA73",
    stopOpacity: 0.0117
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02C378",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchback);
export default __webpack_public_path__ + "static/media/Hatchback.3b2c943e.svg";
export { ForwardRef as ReactComponent };